import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';

export const complaintService = {
  list: () => axios.get(Pathes.Complaint.complaints),
  complaint: id => axios.get(Pathes.Complaint.complaint(id)),
  deleteComplaint: id => axios.delete(Pathes.Complaint.complaint(id)),
  createComplaint: payload => axios.post(Pathes.Complaint.complaints, payload),
  participatingFundraising: () =>
    axios.get(Pathes.Complaint.participating_fundraising),
};
